import MoreMenuTemplate from "../../compiled-templates/MoreMenuTemplate";
import * as ts from "../../common/Translator";
import {NamaKendoWindow} from "../NamaKendoWindow";
import {isMobileDevice} from "../../common/GUIUtilities";
import * as StringUtils from "../../common/StringUtils";
import {matchesUsingNormalization} from "../../widgets/TopPanelSearchSuggestOracle";
import {areEqual, areNotEqual, isEmptyOrNull} from "../../common/NamaCommon";
import * as CommonConstants from "../../constants/CommonConstants";
import {userCanAction} from "../../login/Security";

function findButtonDataWithId(id, buttonsData) {
    let allButtons = [];
    for (let button of buttonsData) {
        if (!button.id)
            continue;
        allButtons.push(button);
        if (button.items)
            for (let subItem of button.items) {
                allButtons.push(subItem);
            }
    }
    for (let button of allButtons) {
        if (button.id === id)
            return button;
    }
}

/**
 *
 * @param buttonsData {MoreMenuItem[]}
 */
export function constructMoreActionsMenu(presenter, buttonsData) {
    let root = $(MoreMenuTemplate({
        translateId: ts.translateId
    }));
    let menu = root.find("#moreActionsMenu");
    let searchField = root.find("#search");
    searchField.kendoTextBox();
    searchField.on("input", () => {
        menu.data("kendoPanelBar").dataSource.data(constructData(presenter, buttonsData, searchField.val()));
        menu.data("kendoPanelBar").reload("> .k-item");
    });
    let window = new NamaKendoWindow(ts.translateId("more"));
    if (isMobileDevice()) {
        window.width = "90%";
        window.height = "90%";
    } else {
        window.width = "40%";
        window.height = "60%";
    }
    window.content.append(root);
    window.doCallBackFirstly = true;
    window.callBackWaitTime = 1;
    window.extraDeductedHeight = 28;
    window.showWindow(() => {
        menu.kendoPanelBar({
            expandMode: "MULTIPLE",
            loadOnDemand: false,
            select: function (e) {
                let dataItem = menu.data("kendoPanelBar").dataItem(e.item);
                let selectedButtonData = findButtonDataWithId(dataItem.id, buttonsData);
                if (!selectedButtonData.items || !selectedButtonData.items.length) {
                    if (selectedButtonData.clickFunction)
                        selectedButtonData.clickFunction();
                    window.closeWindow();
                }

            },
            dataSource: {
                data: constructData(presenter, buttonsData, searchField.data("kendoTextBox").value()),
                serverFiltering: true,
            },
            template: "#if(item.title) {##:item.title##} else {#<div class='k-separator'></div>#}#",
            dataBound: function (e) {
                let separators = menu.find(".k-separator");
                let sepList = [...separators];
                if (sepList.length)
                    sepList.forEach(s => {
                        let spanElement = $(s).parent();
                        spanElement.parent().addClass("menuSeparator");
                        spanElement.remove();
                    });
            }
        });
    });
}

/**
 *
 * @param buttonsData {MoreMenuItem[]}
 * @param value {string}
 * @param subItems {boolean}
 * @returns {*[]}
 */
function constructData(presenter, buttonsData, value, subItems) {
    let data = [];
    let previousIsSeparator = true;
    let query = value || "";
    let queryToLower = query.toLowerCase();
    let arNormailized = StringUtils.normalizeArabic(query);
    let enToArNormalized = StringUtils.normalizeArabic(StringUtils.englishToArabic(query));
    let arToEn = StringUtils.arabicToEnglish(query).toLowerCase();
    for (let item of buttonsData) {
        if (areEqual(item.id, CommonConstants.MORE_MENU_SEPERATOR) && previousIsSeparator)
            continue;
        if (value) {
            if (areNotEqual(item.id, CommonConstants.MORE_MENU_SEPERATOR) && !matchesUsingNormalization(item.id + " " + item.title + item.otherTitle, query, arNormailized, enToArNormalized, arToEn))
                continue;
        }
        if (areNotEqual(item.id, CommonConstants.MORE_MENU_SEPERATOR) && (!userCanAction(presenter.entityType, item.securityID || item.id) || isEmptyOrNull(item.title)))
            continue;
        if (areEqual(item.id, CommonConstants.MORE_MENU_SEPERATOR))
            previousIsSeparator = true;
        else
            previousIsSeparator = false;
        let dItem = {id: item.id, title: item.title};
        if (item.items)
            dItem.items = constructData(presenter, item.items, value, true);
        else
            dItem.items = [];
        data.push(dItem);
    }
    return data;
}
